import { Box, Grid, InputAdornment, TextField, Typography } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import SearchIcon from '@material-ui/icons/Search';
import { useDispatch, useSelector } from 'react-redux';
import { getAssetDataByVendorCode, getAssetwithVendorCode, getVendorData } from '../ReduxStore/VendorDataSlice';
import "./Preventive Maintenance/PreventiveMaintenance.css";
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getMasterTableData } from '../ReduxStore/MastertableSlice';
import { convertUTCtoIST } from '../helpers/DateConvert'
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const customStyles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 9999, // Adjust this value as needed
    }),
};


const SelectAssetComponent = ({ handleAssetSelection, title, pli = false }) => {
    const [searchInput, setSearchInput] = useState('');
    const dispatch = useDispatch();
    const Role = localStorage.getItem("userRole");
    const { response } = useSelector(state => state.vendor);
    const [SupplierOptions, setSupplierOptions] = useState(null);
    const [selectedSupplier, setselectedSupplier] = useState(null);
    const [loading2, setLoading] = useState(false);
    const [masterData, setMasterData] = useState([]);

    const searchInputHandler = (e) => {
        setSearchInput(e.target.value);
        console.log("search Asset", searchInput);
    };

    // const { assetResponse, loading } = useSelector((state) => state.vendor);


    const searchString = searchInput?.toLowerCase() || "";

    // const filteredAssets = assetResponse && assetResponse.filter((asset) => {
    //     return (
    //         asset?.Asset_description?.toLowerCase().includes(searchString) ||
    //         asset?.Asset_no?.toLowerCase().includes(searchString) ||
    //         asset?.vendor?.toLowerCase().includes(searchString) ||
    //         asset?.vendor_description?.toLowerCase().includes(searchString)
    //     );
    // });

    // const filteredAssets2 = masterData && masterData.filter((asset) => {
    //     return (
    //         asset?.["Asset description"]?.toLowerCase().includes(searchString) ||
    //         asset?.["asset_no"]?.toLowerCase().includes(searchString) ||
    //         asset?.["Vendor"]?.toLowerCase().includes(searchString) ||
    //         asset?.["Vendor Descr"]?.toLowerCase().includes(searchString)
    //     );
    // });
    const filteredAssets3 = masterData && masterData.filter((asset) => {
        return (
            (asset?.["asset_text"]?.toLowerCase() || asset?.Asset_description?.toLowerCase()).includes(searchString)
            ||
            (asset?.["asset_no"]?.toLowerCase() || asset?.Asset_no?.toLowerCase()).includes(searchString) ||
            (asset?.["Vendor"]?.toLowerCase() || asset?.vendor?.toLowerCase()).includes(searchString) ||
            (asset?.["Vendor Descr"]?.toLowerCase() || asset?.vendor_group?.toLowerCase()).includes(searchString)
        );
    });

    // console.log("check filter variable", filteredAssets3)


    const getAssetbyVendor = useCallback(async (vendor_code) => {
        try {
            setLoading(true)
            const action = dispatch(getMasterTableData({ page: 1, limit: 500, queryParams: `vendor_code=${vendor_code}` }));
            const res = await action.unwrap();
            if (res.result && res.result.data.some(log => log.hasOwnProperty('pli_submit_last_date'))) {
                // Sort by UTC dates first, then apply formatting
                const sortedLogs = res.result.data
                    .slice() // Clone array to prevent mutation
                    .sort((a, b) => {
                        const dateA = a.pli_submit_last_date
                            ? new Date(a.pli_submit_last_date)
                            : new Date(0); // Handle null as earliest
                        const dateB = b.pli_submit_last_date
                            ? new Date(b.pli_submit_last_date)
                            : new Date(0);
                        return dateB - dateA;
                    })
                    .map(log => ({
                        ...log,
                        pli_submit_last_date: log.pli_submit_last_date
                            ? convertUTCtoIST(log.pli_submit_last_date)  // Format only for display
                            : null
                    }));

                setMasterData(sortedLogs);
            } else {
                setMasterData(res.result.data);
            }
            // if (res.result.data) {
            //     setLoading(false)
            //     if (res.result.data.length > 0) {
            //         setMasterData(res.result.data)
            //     } else {
            //         toast.info("Asset Not Found!")
            //     }
            // };
        } catch (error) {
            toast.error(error.message || "Asset Not Found!");
        } finally {
            setLoading(false)
        }
    }, [dispatch])


    const getAssetList = useCallback(async () => {
        try {
            setLoading(true)
            const action = dispatch(getAssetwithVendorCode());
            const res = await action.unwrap();
            console.log("ALL DATA", res.result)
            // if (res.result) {
            //     setLoading(false)
            //     setMasterData(res.result)
            // };
            if (res.result && res.result.some(log => log.hasOwnProperty('pli_submit_last_date'))) {
                // Sort by UTC dates first, then apply formatting
                const sortedLogs = res.result
                    .slice() // Clone array to prevent mutation
                    .sort((a, b) => {
                        const dateA = a.pli_submit_last_date
                            ? new Date(a.pli_submit_last_date)
                            : new Date(0); // Handle null as earliest
                        const dateB = b.pli_submit_last_date
                            ? new Date(b.pli_submit_last_date)
                            : new Date(0);
                        return dateB - dateA;
                    })
                    .map(log => ({
                        ...log,
                        pli_submit_last_date: log.pli_submit_last_date
                            ? convertUTCtoIST(log.pli_submit_last_date)  // Format only for display
                            : null
                    }));

                setMasterData(sortedLogs);
            } else {
                setMasterData(res.result);
            }
        } catch (error) {
            toast.error(error.message || "Asset Not Found!");
        } finally {
            setLoading(false)
        }
    }, [dispatch])



    useEffect(() => {
        if (Role === "admin") {
            dispatch(getVendorData());
        } else {
            // dispatch(getAssetwithVendorCode());
            getAssetList();
        }
    }, [Role, dispatch, getAssetList])

    useEffect(() => {
        // const Supplierlist = response && response.map(item => item.vendor_group);
        const Supplierlist = response && response.map(item => ({
            label: `${item.vendor_group} (${item.vendor})`, // Concatenate vendor_group and vendor
            value: item.vendor // Use vendor code as the value
        }));
        console.log("Supplierlist", Supplierlist);
        if (Supplierlist) {
            setSupplierOptions(Supplierlist.map((item, index) => ({
                value: item.value, // Use vendor as the value
                label: item.label  // Display concatenated vendor_group and vendor
            })));
        }
    }, [response]);

    useEffect(() => {
        if (selectedSupplier) {
            getAssetbyVendor(selectedSupplier.value);
        }

    }, [getAssetbyVendor, selectedSupplier])


    return (
        <>
            <Box mb={2}>
                <Grid container className='row1'>
                    <Grid item xs={12} sm={5}>
                        <Typography variant="body1" style={{ fontSize: '24px', fontWeight: 300 }}>
                            {title}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3} className='row1'>
                        <TextField
                            placeholder="Search Asset"
                            variant="outlined"
                            size="small"
                            onChange={searchInputHandler}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                </Grid>
                {Role === "admin" && <Grid container className='row1'>
                    <Grid item xs={12} sm={4}>
                        <h3>Select Supplier</h3>
                        <Select
                            styles={customStyles}
                            options={SupplierOptions}
                            placeholder="Select Vendor"
                            isSearchable
                            onChange={setselectedSupplier}
                            isClearable
                        />
                    </Grid>
                </Grid>}
            </Box>
            {loading2 ? (
                <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
                    <GridLoadingSpinner />
                </Box>
            ) : (
                //     <>
                //     {Role === "admin" && filteredAssets2 && filteredAssets2.map((item, index) => (
                //         <Grid container className="assets" key={index} onClick={() => { handleAssetSelection(item) }}>
                //             <Grid item xs={12} sm={2}>
                //                 <h4>Asset No: {item["asset_no"]}</h4>
                //             </Grid>
                //             <Grid item xs={12} sm={4}>
                //                 <h4>Asset Description: {item["Asset description"]}</h4>
                //             </Grid>
                //             <Grid item xs={12} sm={2}>
                //                 <h4>Vendor Code: {item["Vendor"]}</h4>
                //             </Grid>
                //             <Grid item xs={12} sm={4}>
                //                 <h4>Supplier Name: {item["Vendor Descr"]}</h4>
                //             </Grid>
                //         </Grid>
                //     ))}

                //     {Role === "supplier" && filteredAssets && filteredAssets.map((item, index) => (
                //         <Grid container className="assets" key={index} onClick={() => { handleAssetSelection(item) }}>
                //             <Grid item xs={12} sm={2}>
                //                 <h4>Asset No: {item.Asset_no}</h4>
                //             </Grid>
                //             <Grid item xs={12} sm={4}>
                //                 <h4>Asset Description: {item.Asset_description}</h4>
                //             </Grid>
                //             <Grid item xs={12} sm={2}>
                //                 <h4>Vendor Code: {item.vendor}</h4>
                //             </Grid>
                //             <Grid item xs={12} sm={4}>
                //                 <h4>Supplier Name: {item.vendor_description}</h4>
                //             </Grid>
                //         </Grid>
                //     ))}
                // </>
                <>
                    {pli ? (filteredAssets3 && filteredAssets3.map((item, index) => (
                        <Grid container
                            className={`assets ${item.pli_submit_last_date ? 'completed' : ''}`}
                            // className="assets"
                            key={index} onClick={() => { handleAssetSelection(item) }}>
                            <Grid item xs={12} sm={2}>
                                {/* <h4>Asset No: {item["asset_no"] || item.Asset_no}</h4> */}
                                <h4>Asset No: {(item["asset_no"] || item.Asset_no)?.slice(3)}</h4>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <h4>Asset Description: {item["Asset description"] || item.Asset_description}</h4>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                {/* <h4>PLI Last Submit: {item?.pli_submit_last_date ? convertUTCtoIST(item.pli_submit_last_date) : 'NA'}</h4> */}
                                <h4>PLI Last Submit: {item?.pli_submit_last_date || 'NA'}</h4>

                                {/* <h4>PLI Last Submit: {item?.pli_submit_last_date || "NA"}</h4> */}
                            </Grid>
                        </Grid>
                    ))) : (filteredAssets3 && filteredAssets3.map((item, index) => (
                        <Grid container className="assets" key={index} onClick={() => { handleAssetSelection(item) }}>
                            <Grid item xs={12} sm={2}>
                                {/* <h4>Asset No: {item["asset_no"] || item.Asset_no}</h4> */}
                                <h4>Asset No: {(item["asset_no"] || item.Asset_no)?.slice(3)}</h4>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <h4>Asset Description: {item["Asset description"] || item.Asset_description}</h4>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <h4>Vendor Code: {item["Vendor"] || item.vendor}</h4>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <h4>Supplier Name: {item["Vendor Descr"] || item.vendor_group}</h4>
                            </Grid>
                        </Grid>
                    )))}

                </>
            )}
            <ToastContainer />
        </>
    );
}

export default SelectAssetComponent;
